
  import {Component, Vue} from "vue-property-decorator";
  import PagedTableViewSimple from "@/components/PagedTableViewSimple/index.vue";
  import api from '@/api/index'
  import AuditLogStatusColumn from "@/views/audits/components/AuditLogStatusColumn.vue";
  import moment from "moment";

  @Component({
    components: {AuditLogStatusColumn, PagedTableViewSimple}
  })
  export default class MyAuditLog extends Vue{

    private tabName:string = '项目';

    formatCreationTime(value:any){
      if(value){
        return moment(value.log.creationTime).format('YYYY-MM-DD HH:mm:ss');
      } else {
        return '';
      }
    }

    fetchDataOfProject(params:any){
      return api.project.getMyAuditLogs(params);
    }

    fetchDataOfActivity(params:any){
      return api.activity.getMyAuditLogs(params);
    }

    fetchDataOfReimbursement(params:any){
      return  api.reimbursement.getMyAuditLogs(params);
    }

    fetchDataOfPayrollRequisition(params:any){
      return api.payrollRequisition.getMyAuditLogs(params);
    }

    fetchDataOfRefund(params:any){
      return api.refundLog.getMyAuditLogs(params);
    }

  }
